import React, { useEffect, useState } from 'react';
import IconFont from '@/components/icon-font';
import styles from './index.module.css';

interface IModal {
  children: React.ReactNode;
  visible: boolean;
  onClose?: () => void;
  style?: React.CSSProperties;
  wrapStyle?: React.CSSProperties;
}
const Modal = (props: IModal) => {
  const { children, visible = false, onClose, style, wrapStyle } = props;
  const [show, setShow] = useState(visible);

  const handleClose = () => {
    onClose && onClose();
    setShow(false);
  };

  useEffect(() => {
    setShow(visible);
  }, [visible]);

  const modalStyles: React.CSSProperties = style || {};

  return show ? (
    <div
      className={styles.wrap}
      style={{ ...(wrapStyle || {}) }}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <div
        className={styles.modal}
        style={{
          ...modalStyles,
        }}
      >
        <div className={styles.content}>
          <div className={styles.close} onClick={() => handleClose()}>
            <IconFont name="crossBold" fontSize={24}></IconFont>
          </div>
          {children}
        </div>
      </div>
    </div>
  ) : null;
};

export default Modal;
